export const MediaType = {
  Picture: 'picture',
  Video: 'video',
  Music: 'music',
  Archive: 'archive',
  SWF: 'swf',
  Shape: 'shape',
  Document: 'document',
  ThreeD: '3d',
  SecureMusic: 'secure_music',
  SecureVideo: 'secure_video',
  SecureDocument: 'secure_document',
  SecureArchive: 'secure_archive',
  SecureRaw: 'secure_raw'
};